import { BookingLogo } from 'src/modules/booking/components/booking-logo'
import { Icon, Typography } from 'src/modules/core/components'

import classes from './booking-details.module.scss'

type BookingDetailsHeaderProps = {
  providerName: string
  logoUrl?: string | null
  subtitle?: string
}

export function BookingDetailsHeader({
  providerName,
  logoUrl,
  subtitle = 'Review your appointment details',
}: BookingDetailsHeaderProps) {
  return (
    <div className={classes.header}>
      <BookingLogo
        logoUrl={logoUrl}
        alt={providerName}
        className={classes.headerLogo}
        fallback={
          <div className={classes.headerIcon}>
            <Icon name="calendarAlt" />
          </div>
        }
      />
      <Typography variant="h1" className={classes.title}>
        Appointment with {providerName}
      </Typography>
      <Typography variant="body" className={classes.subtitle}>
        {subtitle}
      </Typography>
    </div>
  )
}
